import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["select", "start", "end"]

  connect() {
    // 初始化时如果输入框有值，尝试匹配下拉框状态（可选优化）
  }

  change() {
    const range = this.selectTarget.value
    if (!range) return

    const today = new Date()
    let startDate = new Date()
    let endDate = new Date()

    switch (range) {
      case "today":
        // 今天
        break
      case "yesterday":
        startDate.setDate(today.getDate() - 1)
        endDate.setDate(today.getDate() - 1)
        break
      case "last_7_days":
        startDate.setDate(today.getDate() - 6)
        break
      case "last_30_days":
        startDate.setDate(today.getDate() - 29)
        break
      case "this_month":
        startDate.setDate(1)
        break
      case "last_month":
        startDate.setMonth(today.getMonth() - 1)
        startDate.setDate(1)
        
        endDate.setDate(0) // 上月最后一天
        break
      case "custom":
        // 自定义：清空或保持原状
        this.startTarget.value = ""
        this.endTarget.value = ""
        return
      default:
        return
    }

    this.startTarget.value = this.formatDate(startDate)
    this.endTarget.value = this.formatDate(endDate)
  }

  formatDate(date) {
    const y = date.getFullYear()
    const m = String(date.getMonth() + 1).padStart(2, "0")
    const d = String(date.getDate()).padStart(2, "0")
    return `${y}-${m}-${d}`
  }
}
